import { AppDownloadCta } from "./AppDownloadCta";
import { Footer } from "./Footer";
import { Seo } from "./Seo";
import { SiteHeader } from "./SiteHeader";

export function AppShell({ page, path, navigate, children }) {
  const showAppDownload = !page?.noindex && !["home", "legal", "app"].includes(page?.kind);

  return (
    <div className="shell">
      <Seo page={page} path={path} />
      <div className="site-shell">
        <span id="page-top" className="page-top-anchor" aria-hidden="true" />
        <SiteHeader navigate={navigate} path={path} />
        {children}
        {showAppDownload ? <AppDownloadCta navigate={navigate} /> : null}
        <Footer navigate={navigate} />
      </div>
    </div>
  );
}
